const API_VER = 'v1.0'
export const HREndpoints = {
    HR_EMPLOYEE_URI: `/hr/api/${API_VER}/employees/`,
    HR_DEPARTMENT_URI: `/hr/api/${API_VER}/departments/`,
    HR_RESIGNATNION_URI: `/hr/api/${API_VER}/resignations/`,
}